import { useState } from "react";
import { addMinutes } from "../timeline/helper";
import { CountdownTimer, MUIIcon, Spinner, useCalcRemainingTime } from "../../../widgets";
import { IExtended, useUpdateApproveRejectMutation } from "./properties/extendedApi";
import { useInterval } from "react-use";

export const ServiceRequestApproval = ({ GPExtention, refetch }: { GPExtention?: IExtended, refetch?: any }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [disableButtons, setDisableButtons] = useState<boolean>(false);
    const [showRejectButton, setShowRejectButton] = useState<boolean>(true);
    const [showApproveButton, setShowApproveButton] = useState<boolean>(true);

    const endTime = addMinutes(GPExtention?.sendTime,GPExtention?.otpTimer);
    const { isFuture } = useCalcRemainingTime({ endTime });
    const [updateRecord] = useUpdateApproveRejectMutation();

    useInterval(() => {
        if (GPExtention?.status !== 1 && GPExtention?.status !== 365970002 && GPExtention?.status !== 365970000)
            return;

        refetch()
    }, 5000)

    useInterval(() => {
        if (isFuture !== true) {
            refetch()
        }
    }, (!endTime || !isFuture) ? 5000 : null)

    const handleApprove = (isApproved: boolean) => {
        // if (!BoardingPass) return;
        if (isApproved) {
            const request: IExtended = {
                id: GPExtention?.id,
                status: 365970000
            }
            setLoading(true);
            setDisableButtons(true);
            isApproved ? setShowRejectButton(false) : setShowApproveButton(false);
            updateRecord(request)
                .finally(() => {
                    setLoading(false);
                })
        } else {
            const request: IExtended = {
                id: GPExtention?.id,
                status: 365970001,
                stateCode: 1
            }
            setLoading(true);
            setDisableButtons(true);
            isApproved ? setShowRejectButton(false) : setShowApproveButton(false);
            updateRecord(request)
                .finally(() => {
                    setLoading(false);
                })
        }
    }

    // if (!BoardingPass) return <></>;

    if (GPExtention?.status === 365970000 || GPExtention?.status === 365970001) {
        return <div className="text-center fs-7 fw-semibold my-3">
            Request is <span className="fw-bold">{GPExtention.status === 365970000 && "Approved"}{GPExtention.status === 365970001 && "Rejected"}</span> , no further action required.
        </div>
    }

    if (!endTime || isFuture !== true)
        return <></>

    return (
        <div className="d-flex gap-5 my-3">
            <CountdownTimer endTime={endTime} label='Waiting for Approval' />
            <div className="flex-fill" />
            <div className="d-flex gap-3 align-self-start">
                {showApproveButton && (
                    <button
                        type="button" className="btn btn-sm btn-primary py-2" onClick={() => handleApprove(true)} disabled={loading || disableButtons}>
                        {loading ? <Spinner show={true} /> : <MUIIcon iconName="ThumbUpOutlined" className="me-1" />}
                        <span className='indicator-label'>Approve</span>
                    </button>
                )}
                {showRejectButton && (
                    <button
                        type="button" className="btn btn-sm btn-danger py-2" onClick={() => handleApprove(false)} disabled={loading || disableButtons}>
                        {loading ? <Spinner show={true} /> : <MUIIcon iconName="ThumbDownOutlined" className="me-1" />}
                        <span className='indicator-label'>Reject</span>
                    </button>
                )}
            </div>
        </div>
    )
}